import { Box, styled } from '@mui/material';

export const Content = styled(Box, {
  shouldForwardProp : (prop) => prop !== 'isEnrolled',
})(({ theme, isEnrolled }) => ({
  backgroundColor : theme.palette.primary.white,
  borderRadius    : '8px',
  width           : '100%',
  ...(isEnrolled && { boxShadow: '0px 0px 9px rgba(0, 0, 0, 0.04)' }),
  cursor          : isEnrolled ? 'not-allowed' : 'pointer',

  display    : 'flex',
  alignItems : 'center',
  gap        : '15px',
  padding    : '15px',
  boxSizing  : 'border-box',

  border    : `1px solid ${theme.palette.primary.white}`,
  '&:hover' : {
    border : `1px solid ${theme.palette.primary.blue1}`,
  },
}));

export const IconWrapper = styled(Box)({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  flex           : '0 0 40px',
});
